
define('text!templates/views/Map.html',[],function () { return '<div id="mapView" class="mapView">\n\t<div id="map_canvas" class="mapCanvas">\n\t</div>\n</div>';});

